import PropTypes from 'prop-types'
import { Icon } from '@/components/atoms'
import JsonFormsWrapper from '@/components/common/jsonForms/jsonFormsWrapper/JsonFormsWrapper'
import { mediaCardJsonSchema } from '@/services/schema/mediaCardJsonSchema'
import React, { useEffect, useState } from 'react'
import { getSalesTargetsDownloadMedia } from '@/services/salesTargets'
function MediaCardForm({ imageUri, handleDelete, mediaCardFormData, handleChange, MediaCardUiSchema, label = "" }) {

  const [imageSrc, setImageSrc] = useState()

  useEffect(() => {

    if (imageUri && imageUri.includes('http')) {
      setImageSrc(imageUri)
      return;
    }
    const fetchImage = async () => {

      try {
        const response = await getSalesTargetsDownloadMedia("filePath=" + imageUri);
        const url = URL.createObjectURL(response);
        setImageSrc(url);
      } catch (error) {
        console.error('Download error:', error);
      }
    }
    fetchImage()
    // cleanup objectUrl
    return () => {
      if (imageSrc && imageSrc.startsWith('blob:')) {
        URL.revokeObjectURL(imageSrc)
      }
    }
    // eslint-disable-next-line
  }, [imageUri])

  return (
    <div className="mb-10 grid grid-cols-2 content-start gap-8">
      <div className="media-card">
        {label.length > 0 && (<div data-testid="label-container" className="flex items-center gap-2 mb-4">
          <div className="text-[#EFEFEF] text-sm">{label}</div>
          <span className="text-white text-sm material-icons-outlined" role="img">info</span>
        </div>)}
        <div className="grid grid-cols-2 gap-4 items-center">
          <div className="file-upload">
            {imageSrc ? (
              <img src={imageSrc} alt="Media" />
            ) : (
              <div className="flex items-center justify-center">
                <Icon icon="loading" className="animate-spin text-white" />
              </div>
            )}
          </div>
          <div className="file-details">
            <div className="flex items-end justify-end">
              <Icon icon="delete" size="medium" onClick={handleDelete} className="close cursor-pointer text-right" />
            </div>
            <JsonFormsWrapper
              jsonschema={mediaCardJsonSchema}
              uischema={MediaCardUiSchema}
              data={mediaCardFormData}
              onChange={handleChange}
            // Updating form data on change
            />
          </div>
        </div>
      </div>
    </div>
  )
}

MediaCardForm.propTypes = {
  imageUri: PropTypes.string.isRequired,
  handleDelete: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  mediaCardFormData: PropTypes.shape({
    title: PropTypes.string,
    imageId: PropTypes.string,
    optIn: PropTypes.bool,
  }).isRequired,
}

export default MediaCardForm
